import API from 'js/lib/api';
import csrfToken from 'js/lib/csrfToken';

import { getActionUrl } from 'bundles/user-account/common/lib';

/**
 *
 * Utility function to log out the user.
 */
export const logOutUser = async () => {
  const logOutApi = API(getActionUrl('logout', csrfToken.get()), { type: 'rest' });

  await logOutApi.post('', {
    contentType: 'application/x-www-form-urlencoded',
    processData: true,
  });
};
